import React from 'react'
import { Alert, Button, notification, Typography } from 'antd'
import { callApi } from '../../../context/api'

const { Text } = Typography

const EmailVerification = () => {
	const sendEmail = () => {
		callApi(`/auth/send-verification-email`, { method: 'POST' }).then((response) => {
			if (response.ok) {
				notification.success({ message: 'Email was successfully sent' })
			} else {
				notification.error({ message: `An error occurred: ${response.payload.data?.message}` })
			}
		})
	}

	return (
		<Alert
			type="warning"
			showIcon
			message={
				<Text>
					Please check your email and verify your account. If you did not receive it (check spam) click
					<Button style={{ height: 20, padding: 0, margin: 2 }} type="link" onClick={sendEmail}>
						here
					</Button>
					to send a new verification
				</Text>
			}
			style={{ margin: 10, padding: 15 }}
		/>
	)
}

export default EmailVerification
